export default "__VITE_ASSET__BiGpb9HI__"